import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Thumbnail from './SliderThumbnail';
import TimelineThumbnail from './TimelineThumbnail';
import ProducerNotes from '../../objects/producerNotes/ProducerNotes';
import NotReadyYet from '../../objects/producerNotes/NotReadyYet';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as enviromentHelper from '../../../helpers/environmentHelper';
import {getScreenComponentByType} from '../../../helpers/componentHelper';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import * as navigationHelper from '../../../helpers/navigationHelper';
import _ from 'lodash';

class SliderScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screen: this.props.screen,
            userData: this.props.userData,
            showContentOutlineInPreview: props.showContentOutlineInPreview,
            locale: appHelper.getLocalData(this.props.screen),
            status: userDataHelper.getScreenUserData(this.props.userData, this.props.screen.screen_id).status,// objectConstants.STATUS_IN_PROGRESS,
            callbacks: {},
            assets: {
                background: {
                    src: "",
                }
            },
            activeScreen: {},
            viewedScreens: [],
            renderedScreens: [],
            enabledScreens: [],
            completeScreens: [],
            checkNextSlideBtnState: false,
            producerNotes: appHelper.getScreenNotes(undefined, this.props.screen, this.props.showContentOutlineInPreview, props.contentData.experience.is_preview),
            screenIsReady: this.props.screen.sub_screens.length > 0, //&& appHelper.canSeeContent(this.props.screen),
            focusedTab: this.props.screen.sub_screens[0],
            tabCallbacks: {},
            updateTabIndex: false,
            isOpenNavigation: appHelper.getBiteById(this.props.biteCallbacks.getBiteId()).navigation_type === objectConstants.PROGRESSION_TYPE_OPEN,
            canThumbnailsAnimate: false,
            setThumbnailInitialState: true,
            continue_label: appHelper.getLocaleString("continue_label"),
            setNextButton: userDataHelper.getScreenUserData(this.props.userData, this.props.screen.screen_id).status === objectConstants.STATUS_COMPLETE,
            hasScreenBanner: false,
            bannerIsMaxSize: enviromentHelper.getEnvironment().window.orientation === objectConstants.ORIENTATION_PORTRAIT,
            env: enviromentHelper.getEnvironment(),
            showBanner: true
        };
        this.getScreenId = this.getScreenId.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.checkScreenStatus = this.checkScreenStatus.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.setEnabledTabs = this.setEnabledTabs.bind(this);
        this.setTabActive = this.setTabActive.bind(this);
        this.onSubScreenComplete = this.onSubScreenComplete.bind(this);
        this.goToNextSubScreen = this.goToNextSubScreen.bind(this);
        this.hasNextSubScreen = this.hasNextSubScreen.bind(this);
        this.checkScreenComplete = this.checkScreenComplete.bind(this);
        this.updateScreenResults = _.debounce(this.updateScreenResults.bind(this), 300);
        this.setScreenAccessed = _.debounce(this.setScreenAccessed.bind(this), 300);
        this.navigateToNextScreen = this.navigateToNextScreen.bind(this);
        this.checkScreenStatus();
        this.setRenderedScreens = this.setRenderedScreens.bind(this);
        this.setPrevSlideBtnDisplayState = this.setPrevSlideBtnDisplayState.bind(this);
        this.onPrevSlideBtnClicked = this.onPrevSlideBtnClicked.bind(this);
        this.setPrevSlideBtnClass = this.setPrevSlideBtnClass.bind(this);
        this.setNextSlideBtnDisplayState = this.setNextSlideBtnDisplayState.bind(this);
        this.onNextSlideBtnClicked = this.onNextSlideBtnClicked.bind(this);
        this.setNextSlideBtnClass = this.setNextSlideBtnClass.bind(this);
        this.animateSlider = this.animateSlider.bind(this);
        this.onAnimateSliderComplete = this.onAnimateSliderComplete.bind(this);
        this.setScreenHasBeenViewed = this.setScreenHasBeenViewed.bind(this);
        this.checkScreenHasBeenViewed = this.checkScreenHasBeenViewed.bind(this);
        this.checkScreenIsEnabled = this.checkScreenIsEnabled.bind(this);
        this.completeScreen = this.completeScreen.bind(this);
        this.setScreenNotReadyYet = this.setScreenNotReadyYet.bind(this);
        this.onPrevSlideKeyboardAccessed = this.onPrevSlideKeyboardAccessed.bind(this);
        this.onNextSlideKeyboardAccessed = this.onNextSlideKeyboardAccessed.bind(this);
        this.getPrevTab = this.getPrevTab.bind(this);
        this.getNextTab = this.getNextTab.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.setTabCallbacks = this.setTabCallbacks.bind(this);
        this.updateSlideTabIndex = this.updateSlideTabIndex.bind(this);
        this.setLayout = this.setLayout.bind(this);
        this.setThumbnailComponent = this.setThumbnailComponent.bind(this);
        this.setCanThumbnailsAnimate = this.setCanThumbnailsAnimate.bind(this);
        this.setThumbnailPosition = _.debounce(this.setThumbnailPosition.bind(this), 300);
        this.goToScreen = this.goToScreen.bind(this);
        this.getNextlessonLocation = this.getNextlessonLocation.bind(this);
        this.handleNextButton = this.handleNextButton.bind(this);
        this.scaleBanner = this.scaleBanner.bind(this);
        this.resizeWatcher = this.resizeWatcher.bind(this);
        this.hideBanner = this.hideBanner.bind(this);
        //refs
        this.bannerImage = React.createRef();
    }

    componentDidMount() {
        window.addEventListener("resize", this.resizeWatcher);
        this.props.actions.setNextButtonState(false);
        this.setScreenAccessed();
        this.props.biteCallbacks.showHeader(true);
        this.props.actions.setScreenTitle(this.state.locale.title);
        this.getAssets();
        this.setCallbacks();
        this.setTabCallbacks();
        this.setCanThumbnailsAnimate();
        if (this.state.screenIsReady) {
            this.setEnabledTabs();
            this.setRenderedScreens();
            this.setTabActive(this.state.screen.sub_screens[0]);
        } else {
            this.setScreenNotReadyYet();
        }

    }

    componentWillReceiveProps(nextProps) {
        let screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
        if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
                checkNextSlideBtnState: true,
                enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
                completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completeScreens,
                setNextButton: true,

            });
        } else if (this.state.isOpenNavigation) {
            this.setState({
                enabledScreens: Object.assign([], this.state.screen.sub_screens)
            });
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                continue_label: appHelper.getLocaleString("continue_label")
            });
            this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
        }

        if (this.state.showContentOutlineInPreview !== nextProps.showContentOutlineInPreview) {
            this.setState({
                showContentOutlineInPreview: nextProps.showContentOutlineInPreview,
                producerNotes: appHelper.getScreenNotes(undefined, this.state.screen, nextProps.showContentOutlineInPreview, this.props.contentData.experience.is_preview),
            });
        }

        this.setState({userData: Object.assign({}, nextProps.userData)});
    }

    componentDidUpdate() {
        if (this.state.checkNextSlideBtnState) {
            this.setNextSlideBtnDisplayState(this.state.activeScreen);
        }

        if (this.state.updateTabIndex) {
            this.updateSlideTabIndex();
        }

        if (this.state.setThumbnailInitialState) {
            this.setThumbnailPosition(0, false);
        }
        if (this.state.setNextButton) {
            this.handleNextButton();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeWatcher);
    }

    resizeWatcher() {
        let env = enviromentHelper.getEnvironment();
        if ((env.window.size !== this.state.env.window.size || env.window.orientation !== this.state.env.window.orientation)) {
            this.setState({
                env: env,
                bannerIsMaxSize: env.window.orientation === objectConstants.ORIENTATION_PORTRAIT
            });
        }
    }


    setScreenAccessed() {
        this.props.actions.setScreenAccessed(this.state.screen);
    }

    setScreenNotReadyYet() {
        this.setState({status: objectConstants.STATUS_COMPLETE, setNextButton: true});
        this.updateScreenResults(objectConstants.STATUS_COMPLETE);
    }

    checkScreenStatus() {
        let screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
        if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
                enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
                completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completeScreens,
                setNextButton: true,
            });
        } else if (this.state.isOpenNavigation) {
            this.setState({
                enabledScreens: Object.assign([], this.state.screen.sub_screens)
            });
        }
        /* let screenStatus = getScreenUserData(this.props.userData, this.props.screen.screen_id).status;
         let reviewMode = screenStatus === objectConstants.STATUS_COMPLETE && localStorage.post_completion_mode === appConstants.POST_COMPLETION_MODE_REVIEW;
        // console.log(`reviewMode: ${this.state.reviewMode} - line 120`);
         this.setState({status: screenStatus, checkCompletionStatus: true, reviewMode: reviewMode, propsUpdated: true});
         */
    }

    getAssets() {
        let background = {};

        if (appHelper.isDefined(this.state.screen.assets.background)) {
            background = appHelper.getBackgroundAsset(this.state.screen.assets.background);
        }

        this.setState({
            assets: Object.assign({}, this.state.assets, {
                background: appHelper.isDefined(background.src) ? background : this.state.assets.background
            })
        });
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setCallbacks() {
        this.setState({
            callbacks: Object.assign({}, this.props.biteCallbacks, {
                //onObjectComplete: this.onObjectComplete,
                getScreenId: this.getScreenId,
                getBiteId: this.getBiteId,
                onSubScreenComplete: this.onSubScreenComplete,
                goToNextSubScreen: this.goToNextSubScreen,
                hasNextSubScreen: this.hasNextSubScreen,
                completeScreen: this.completeScreen,
                //objectIsEnabled: this.objectIsEnabled,
                //objectIsComplete: this.objectIsComplete,
                //storeUserResponse: this.storeUserResponse,
                //scrollTo: this.scrollTo,
                //isReviewMode: this.isReviewMode
            })
        });
    }

    getScreenId() {
        return this.state.screen.screen_id;
    }

    getBiteId() {
        //console.log(`getBiteId`);
        return this.props.biteCallbacks.getBiteId();
    }

    setEnabledTabs() {
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            if (this.state.isOpenNavigation) {
                this.setState({
                    enabledScreens: Object.assign([], this.state.screen.sub_screens)
                });
            } else {
                this.setState({enabledScreens: dataHelper.immutablePush(this.state.enabledScreens, this.state.screen.sub_screens[0])});
            }

        }
    }

    checkScreenIsEnabled(screen) {
        let enabledIndex = appHelper.getArrayObjectIndexByKey(this.state.enabledScreens, "screen_id", screen.screen_id);
        return enabledIndex > -1;
    }

    checkScreenHasBeenViewed(screen) {
        let viewedIndex = appHelper.getArrayObjectIndexByKey(this.state.viewedScreens, "screen_id", screen.screen_id);
        return viewedIndex > -1;
    }


    updateSlideTabIndex() {
        this.setState({updateTabIndex: false});
        let activeScreenId = this.state.activeScreen.screen_id;
        for (let i = 0; i < this.state.viewedScreens.length; i++) {
            let screen = this.state.viewedScreens[i];

            let el = document.getElementById(`slide_${screen.screen_id}`);
            let tabbableElements = [];

            if (appHelper.isDefined(el) && el !== null) {
                tabbableElements = dataHelper.getAllTabbableElements(el);
            }

            _.forEach(tabbableElements, function (tabEl) {
                if (screen.screen_id === activeScreenId) {
                    tabEl.tabIndex = 0;
                } else {
                    tabEl.tabIndex = -2;
                }
            });

        }
    }


    setTabActive(screen) {
        //set renderedObject to empty so that when component updates we make sure we can set it again and we get exactly what we want rendered

        this.setState(
            {
                activeScreen: screen,
                focusedTab: screen,
                updateTabIndex: true
            });

        this.setPrevSlideBtnDisplayState(screen);
        this.setNextSlideBtnDisplayState(screen);
        if (this.state.canThumbnailsAnimate) {
            let screenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
            this.setThumbnailPosition(screenIndex, true);
        }
        this.animateSlider(screen);
        this.setScreenHasBeenViewed(screen);
        //this.setBackButtonDisplayState(object);
        //this.setContinueButtonDisplayState(object);
    }

    animateSlider(screen) {
        let screenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        let slider = this.refs[`${this.state.screen.screen_id}_slide_container`];
        let leftPos = 0 - (screenIndex * 100);
        if (appHelper.isDefined(slider)) {

            TweenLite.to(slider, 1, {
                left: `${leftPos}%`,
                ease: Expo.easeInOut,
                onComplete: this.onAnimateSliderComplete,
                onCompleteParams: [screen]
            });
        }
    }

    onAnimateSliderComplete(screen) {
        //viewedObjects
        this.setScreenHasBeenViewed(screen);
    }

    setScreenHasBeenViewed(screen) {
        let viewedIndex = appHelper.getArrayObjectIndexByKey(this.state.viewedScreens, "screen_id", screen.screen_id);
        if (viewedIndex === -1) {
            this.setState({viewedScreens: dataHelper.immutablePush(this.state.viewedScreens, screen)});
        }

    }


    setRenderedScreens() {
        let renderedScreens = [];
        _.forEach(this.state.screen.sub_screens, function (sub_screen) {
            let screenType = Object.assign({}, getScreenComponentByType(sub_screen.screen_type),
                {
                    data: sub_screen
                }
            );
            renderedScreens = dataHelper.immutablePush(renderedScreens, screenType);
        });

        this.setState({renderedScreens: Object.assign([], renderedScreens)});
    }

    setPrevSlideBtnDisplayState(screen) {
        let screenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        this.setState({enablePrevSlideBtn: screenIndex > 0});
    }

    onPrevSlideBtnClicked() {
        if (this.state.enablePrevSlideBtn) {
            let screenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", this.state.activeScreen.screen_id);
            if (screenIndex > 0) {
                this.setTabActive(this.state.screen.sub_screens[screenIndex - 1]);
            }
        }
    }

    setPrevSlideBtnClass() {
        return this.state.enablePrevSlideBtn ? "" : "disabled";
    }

    setNextSlideBtnDisplayState(screen) {
        if (appHelper.isDefined(screen)) {
            let screenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
            if (screenIndex < (this.state.screen.sub_screens.length - 1)) {
                let nextScreen = this.state.screen.sub_screens[screenIndex + 1];
                let nextScreenEnabled = appHelper.getArrayObjectIndexByKey(this.state.enabledScreens, "screen_id", nextScreen.screen_id);
                this.setState({
                    enableNextSlideBtn: this.state.status === objectConstants.STATUS_COMPLETE || this.state.isOpenNavigation ? true : nextScreenEnabled > -1,
                    //enableNextSlideBtn: this.state.status === objectConstants.STATUS_COMPLETE,
                    checkNextSlideBtnState: false
                });
            } else {
                this.setState({
                    enableNextSlideBtn: this.state.status === objectConstants.STATUS_COMPLETE || this.state.isOpenNavigation,
                    checkNextSlideBtnState: false
                });
            }
        }
    }

    onNextSlideBtnClicked() {
        if (this.state.enableNextSlideBtn) {

            let screenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", this.state.activeScreen.screen_id);
            if ((this.state.status === objectConstants.STATUS_COMPLETE || this.state.isOpenNavigation) && screenIndex === (this.state.screen.sub_screens.length - 1)) {
                this.navigateToNextScreen();
            } else {
                if (this.hasNextSubScreen(this.state.activeScreen)) {
                    this.setTabActive(this.state.screen.sub_screens[screenIndex + 1]);
                }
            }
        }
    }

    setNextSlideBtnClass() {
        return this.state.enableNextSlideBtn ? "" : "disabled";
    }

    onSubScreenComplete(screen) {
        //console.log(screen);
        let completionIndex = appHelper.getArrayObjectIndexByKey(this.state.completeScreens, "screen_id", screen.screen_id);
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        let nextScreen = {};

        if (subScreenIndex < (this.state.screen.sub_screens.length - 1)) {
            nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
        }

        if (completionIndex === -1) {
            this.setState(
                {
                    completeScreens: dataHelper.immutablePush(this.state.completeScreens, screen),
                    enabledScreens: typeof nextScreen.screen_id !== "undefined" ? dataHelper.immutablePush(this.state.enabledScreens, nextScreen) : Object.assign([], this.state.enabledScreens),
                    checkContinueBtnState: true,
                    checkNextSlideBtnState: true
                }
            );

            // this.updateScreenResults(this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS: objectConstants.STATUS_COMPLETE, screen.screen_id);
        }

        this.checkScreenComplete();
        this.setNextSlideBtnDisplayState(screen);
    }

    hasNextSubScreen(screen) {
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        return subScreenIndex < (this.state.screen.sub_screens.length - 1);
    }

    goToNextSubScreen(screen) {
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        if (this.hasNextSubScreen(screen)) {
            let nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
            this.setTabActive(nextScreen);
        } else {
            this.navigateToNextScreen();
        }
    }

    goToScreen(goTo) {
        this.props.actions.setNewLessonLocation(goTo);
    }


    navigateToNextScreen() {
        if (appHelper.isDefined(this.state.screen.next_screen_id) && !isNaN(this.state.screen.next_screen_id)) {
            this.goToScreen(this.state.screen.next_screen_id);
        } else {
            let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
            if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                this.context.router.push('menu');
            } else {
                this.goToScreen(nextScreenId);
            }
        }
    }

    getNextlessonLocation() {
        let next_lesson_location = 0;
        if (appHelper.isDefined(this.state.screen.next_screen_id) && !isNaN(this.state.screen.next_screen_id)) {
            next_lesson_location = this.state.screen.next_screen_id;
        } else {
            let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
            if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                next_lesson_location = -1;
            } else {

                next_lesson_location = navigationHelper.getNextLessonLocation(this.getScreenId());
            }
        }

        return next_lesson_location;
    }

    handleNextButton() {
        this.setState({setNextButton: false});
        let next_lesson_location = this.getNextlessonLocation();
        if (next_lesson_location !== 0) {
            this.props.actions.setNextButtonState(true, next_lesson_location);
        }
    }

    checkScreenComplete() {
        if (this.state.completeScreens.length >= this.state.screen.sub_screens.length) {
            this.setState(
                {
                    status: objectConstants.STATUS_COMPLETE,
                    setNextButton: true,
                }
            );
            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
        }
    }

    //used when child screen terminates
    completeScreen() {
        this.setState(
            {
                status: objectConstants.STATUS_COMPLETE,
                setNextButton: true,
            }
        );
        this.updateScreenResults(objectConstants.STATUS_COMPLETE);
    }

    updateScreenResults(screen_status) {
        let params = {
            bite_id: this.getBiteId(),
            screen_id: this.getScreenId(),
            screen_status: screen_status,
            object_status: objectConstants.STATUS_COMPLETE,
        };
        this.props.actions.updateScreenResults(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if (screen_status === objectConstants.STATUS_COMPLETE) {
                    this.props.actions.setScreenComplete(this.state.screen);
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    onPrevSlideKeyboardAccessed(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.onPrevSlideBtnClicked();
        }
    }

    onNextSlideKeyboardAccessed(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if (this.checkScreenIsEnabled(this.state.focusedTab)) {
                this.onNextSlideBtnClicked();
            }
        }
    }

    getPrevTab() {
        let tabIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", this.state.focusedTab.screen_id);
        let nextTab = this.state.screen.sub_screens[tabIndex - 1];
        if (tabIndex <= 0) {
            nextTab = this.state.screen.sub_screens[this.state.screen.sub_screens.length - 1];
        }
        this.setState({focusedTab: Object.assign({}, nextTab)});
    }

    getNextTab() {
        let tabIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", this.state.focusedTab.screen_id);
        let nextTab = this.state.screen.sub_screens[tabIndex + 1];
        if (tabIndex === (this.state.screen.sub_screens.length - 1)) {
            nextTab = this.state.screen.sub_screens[0];
        }
        this.setState({focusedTab: Object.assign({}, nextTab)});
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if (appHelper.getArrayObjectIndexByKey(this.state.enabledScreens, "screen_id", this.state.focusedTab.screen_id) > -1) {
                this.setTabActive(this.state.focusedTab);
            }
        }

        if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
            event.preventDefault();
            this.getPrevTab();
        }

        if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
            event.preventDefault();
            this.getNextTab();
        }

        if (event.which === keyboardConstants.ARROW_UP_KEY) {
            event.preventDefault();
            this.getPrevTab();
        }

        if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
            event.preventDefault();
            this.getNextTab();
        }
    }

    setTabCallbacks() {
        this.setState({
            tabCallbacks: Object.assign({}, this.state.tabCallbacks, {
                setKeyboardAccessibility: this.setKeyboardAccessibility
            })
        });
    }

    setLayout() {
        if (appHelper.isDefined(this.state.screen.slider_type) && this.state.screen.slider_type === objectConstants.SLIDER_TYPE_HORIZONTAL_TIMELINE) {
            return "horz-slider-timeline";
        } else {
            return "horz-slider-screen";
        }
    }

    setThumbnailComponent() {
        if (appHelper.isDefined(this.state.screen.slider_type) && (this.state.screen.slider_type === objectConstants.SLIDER_TYPE_HORIZONTAL_TIMELINE)) {
            return TimelineThumbnail;
        } else {
            return Thumbnail;
        }

    }

    setCanThumbnailsAnimate() {
        let canAnimate = false;
        if (appHelper.isDefined(this.state.screen.slider_type) && this.state.screen.slider_type === objectConstants.SLIDER_TYPE_HORIZONTAL_TIMELINE) {
            canAnimate = true;
        }
        this.setState({
            canThumbnailsAnimate: canAnimate,
            setThumbnailInitialState: canAnimate
        });
    }

    setThumbnailPosition(screenIndex, animate) {
        this.setState({
            setThumbnailInitialState: false
        });

        let sliderContainer = this.refs[`${this.state.screen.screen_id}_thumbnailContainer`];
        let slider = this.refs[`${this.state.screen.screen_id}_thumbnails`];
        let thumbnail = document.getElementById(`thumbnail_${this.state.screen.sub_screens[screenIndex].screen_id}`);
        let sliderContainer_width = sliderContainer.offsetWidth;
        let thumbnail_width = thumbnail.offsetWidth;
        //console.log(`thumbnail_width`,thumbnail_width);
        let thumbnail_left = thumbnail.offsetWidth * screenIndex;
        //console.log(`thumbnail_left`,thumbnail_left);


        // let leftPos = (sliderContainer_width / 2) - (thumbnail_width / 2) - thumbnail_left + 12;
        let leftPos = (sliderContainer_width / 2) - (thumbnail_width / 2) - thumbnail_left + 6;
        //console.log(`leftPos`,leftPos);
        if (appHelper.isDefined(slider)) {

            if (animate) {

                TweenLite.to(slider, 0.5, {
                    left: leftPos,
                });
            } else {

                TweenLite.set(slider, {
                    left: leftPos,
                    opacity: 1
                });
            }
        }
    }

    scaleBanner(event) {
        event.preventDefault();
        event.stopPropagation();
        if (appHelper.isDefined(event.which)) {
            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
                this.setState({
                    bannerIsMaxSize: !this.state.bannerIsMaxSize
                });
            }
        } else {
            this.setState({
                bannerIsMaxSize: !this.state.bannerIsMaxSize
            });
        }
    }

    hideBanner(event){
        event.preventDefault();
        event.stopPropagation();
        if(appHelper.isDefined(event.which)) {
            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
                this.setState({showBanner: false});
            }
        }else{
            this.setState({showBanner: false});
        }
    }


    render() {
        let ThumbnailComponent = this.setThumbnailComponent();
        let layoutStyle = this.setLayout();
        return (
            <div className="customer-scenario">
                {
                    !this.state.screen.use_bg_as_banner_on_devices || (this.state.screen.use_bg_as_banner_on_devices && this.state.env.window.orientation !== objectConstants.ORIENTATION_PORTRAIT)
                        ?
                        <div className="background-container">
                            <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                        </div>
                        :
                        null
                }
                <div className="screen-container">

                    <div className={`${layoutStyle} ${this.state.bannerIsMaxSize ? "scale-banner-max" : "scale-banner-min"} `}>
                        {
                            this.state.screen.use_bg_as_banner_on_devices && this.state.env.window.orientation === objectConstants.ORIENTATION_PORTRAIT && this.state.showBanner
                                ?
                                <div className="background-banner">
                                    <div className={`close-banner-btn`} onClick={this.hideBanner} onKeyDown={this.hideBanner} role="link" tabIndex={0}/>
                                    <div className={`banner-image`}>
                                        <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                                    </div>

                                </div>
                                :
                                null
                        }
                        <div className={`slider`}>
                            {this.state.screen.sub_screens.length > 1 && this.state.screenIsReady
                                ?
                                <div className={`slider-prev-slide-btn ${this.setPrevSlideBtnClass()}`}
                                     onClick={this.onPrevSlideBtnClicked} onKeyDown={this.onPrevSlideKeyboardAccessed}
                                     role="link" tabIndex="0"/>
                                : null
                            }
                            <div className="slider-container" ref={`${this.state.screen.screen_id}_sliderContainer`}>
                                {
                                    this.state.screen.sub_screens.length > 1
                                        ?
                                        <div className="thumbnail-wrapper">
                                            <div
                                                className={`thumbnail-container ${this.state.screen.include_icon ? "icon-list" : ""} `}
                                                ref={`${this.state.screen.screen_id}_thumbnailContainer`}>
                                                <div className={`thumbnail-list `}
                                                     role="tablist"
                                                     ref={`${this.state.screen.screen_id}_thumbnails`}>
                                                    {this.state.screen.sub_screens.map((sub_screen, index) =>
                                                        typeof this.state.activeScreen.screen_id !== "undefined" && this.state.screenIsReady
                                                            ? <ThumbnailComponent
                                                                key={`${sub_screen.screen_id}_thumbnail`}
                                                                index={index}
                                                                parentScreen={this.state.screen}
                                                                screen={sub_screen}
                                                                activeScreenId={this.state.activeScreen.screen_id}
                                                                enabledScreens={this.state.enabledScreens}
                                                                completeScreens={this.state.completeScreens}
                                                                onClickFunc={this.setTabActive}
                                                                focusedTab={this.state.focusedTab}
                                                                tabCallbacks={this.state.tabCallbacks}
                                                            />
                                                            : null
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        : null
                                }

                                <div
                                    className={`slider-body-content ${this.state.screen.sub_screens.length < 2 ? "single-slider" : ""} ${this.state.screen.include_icon ? "icon-body" : ""}`}
                                    ref={`${this.state.screen.screen_id}_feed`}>
                                    <div className="slide-container"
                                         ref={`${this.state.screen.screen_id}_slide_container`}>

                                        {this.state.renderedScreens.map(renderedScreen =>
                                            <div key={renderedScreen.data.screen_id} className={`slide`} role="tabpanel"
                                                 id={`slide_${renderedScreen.data.screen_id}`}>
                                                {this.checkScreenIsEnabled(renderedScreen.data) && this.checkScreenHasBeenViewed(renderedScreen.data) && this.state.screenIsReady
                                                    ?
                                                    <renderedScreen.component screen={renderedScreen.data}
                                                                              parentScreen={this.state.screen}
                                                                              biteCallbacks={this.state.callbacks}/>
                                                    :
                                                    null
                                                }
                                            </div>
                                        )}
                                        {
                                            !this.state.screenIsReady
                                                ?

                                                <div>

                                                    {
                                                        this.state.producerNotes.show_notes
                                                            ?
                                                            <ProducerNotes notes={this.state.producerNotes.notes}
                                                                           screen_id={this.state.screen.screen_id}/>
                                                            :
                                                            null
                                                    }
                                                    <NotReadyYet screen_id={this.state.screen.screen_id}
                                                                 onContinue={this.navigateToNextScreen}/>

                                                </div>
                                                :
                                                null
                                        }

                                    </div>
                                </div>
                            </div>
                            {this.state.screen.sub_screens.length > 1 && this.state.screenIsReady
                                ?
                                <div className={`slider-next-slide-btn ${this.setNextSlideBtnClass()}`}
                                     onClick={this.onNextSlideBtnClicked} onKeyDown={this.onNextSlideKeyboardAccessed}
                                     role="link" tabIndex="0"/>
                                :
                                null
                            }
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

/*
* <div className="tabbed-body-footer">
                            <div className="text-center">
                                footer

                            </div>
                        </div>
* */

SliderScreen.propTypes = {
    screen: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    titles: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    showContentOutlineInPreview: PropTypes.bool.isRequired,
};

SliderScreen.contextTypes = {
    router: PropTypes.object,

};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
        titles: state.titles,
        userData: state.userData,
        showContentOutlineInPreview: state.showContentOutlineInPreview,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SliderScreen);



/** WEBPACK FOOTER **
 ** ./src/components/screens/sliderScreen/SliderScreen.js
 **/